export class ContextJotaiActionsBase{}